<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">广告配置</p>
      <div class="content-input" style="justify-content: space-between">
        <div class="content-input-item">
          <label>广告功能是否开启：</label>
          <el-switch v-model="sysAdSwitchCache" size="large" active-text="开" inactive-text="关" inline-prompt @change="switchChange" />
        </div>
        <div class="content-input-item">
          <div style="margin-right: 16px">
            <p>注册时间：{{sysAdUserRegDate}}</p>
            <p style="color: red; font-size: 12px">*用户的注册时间小于配置时间时，为旧用户</p>
          </div>
          <el-button type="primary" @click="editRegDateDialog()">修改时间</el-button>
        </div>
      </div>
      <div class="content-table" style="margin: 24px 0">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            border
            @cell-click="showEdit"
        >
          <el-table-column property="user" label="用户"></el-table-column>
          <el-table-column property="sex" label="性别"></el-table-column>
          <el-table-column property="isVip" label="VIP"></el-table-column>
          <el-table-column property="value" label="概率（%）" class-name="cursor">
            <template #default="scope">
              <div class="item" v-if="!scope.row.showInput">
                <p>{{scope.row.value}}</p>
              </div>
              <div class="item" v-else>
                <el-input type="text" v-model="scope.row.value" style="margin-right: 8px; flex: 1" @focusout="submit(scope.row)"/>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
// import BtnGroup from '../../components/BtnGroup'
import {getSysAdConfig, updateSysAdConfig} from '@/api/url'
import {getFormData, imgPostFormData, postFormData} from '@/api/api'
import Dialog from "@/assets/js/dialog";
import NickNameDialog from "./components/NickNameDialog";
import SearchComponents from "@/components/SearchComponents";
import {positiveIntReg} from "@/assets/shared/reg-constant";
import adRegDate from "@/views/sys/components/adRegDate";

export default {
  name: "SysNickName",
  components: { SearchComponents },
  data() {
    return {
      searchLoading: false,
      listLoading: false,
      pageDataList: [],
      sysAdSwitchCache: false,
      sysAdUserRegDate: '',
    }
  },
  methods: {


    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage() {
      this.searchLoading = true;
      this.listLoading = true;
      getFormData(getSysAdConfig).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          this.pageDataList = []
          let dataList = data.data.sysAdUserRateMap;
          this.sysAdSwitchCache = data.data.sysAdSwitchCache;
          this.sysAdUserRegDate = data.data.sysAdUserRegDate;
          for(let k in dataList) {
            // console.log(k,":",dataList[k])
            let arr = k.split('_')
            let obj = {
              filed: k,
              user: arr[1] == 0?'旧用户':'新用户',
              sex: arr[2] == 1?'男':'女',
              isVip: arr[3] == 0?'否':'是',
              value: dataList[k],
              oldValue: dataList[k],
              showInput: false
            }
            this.pageDataList.push(obj)
          }
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch(() => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    showEdit(row, column, cell, event) {
      this.pageDataList.map(item => {
        item.showInput = false
      })
      if(column.label == '概率（%）') {
        row.showInput = true
      }
    },

    submit(row) {
      if(!positiveIntReg.test(row.value)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: "请输入正确的概率数值",
          type: 'warning'
        });
        row.value = row.oldValue
        return false
      }else if(row.value > 100) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: "概率不能超过100",
          type: 'warning'
        });
        row.value = row.oldValue
        return false
      }
      let param = {}
      param['key'] = 'sysAdUserRateMap';
      param['filed'] = row.filed
      param['value'] = row.value
      postFormData(updateSysAdConfig, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.$message({
            message: msg,
            type: 'success',
            duration: 2000,
          })
          this.getPage()
        }else {
          this.$message({
            message: msg,
            type: 'warning',
            duration: 2000,
          })
        }
      })
    },

    switchChange(val) {
      let param = {}
      param['key'] = 'sysAdSwitchCache';
      param['value'] = val
      postFormData(updateSysAdConfig, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.$message({
            message: msg,
            type: 'success',
            duration: 2000,
          })
          this.getPage()
        }else {
          this.$message({
            message: msg,
            type: 'warning',
            duration: 2000,
          })
        }
      })
    },


    editRegDateDialog() {
      let _title = '';
      _title = ''
      Dialog.open({
        title: _title,
        component: adRegDate,
        data: {
          sysAdUserRegDate: this.sysAdUserRegDate,
          width: '500px'
        },
        confirm: (result) => {
            this.sysAdUserRegDate = result
        }
      })
    },

  },
  mounted() {
    this.getPage();
  }
}
</script>

<style scoped>

</style>
